import * as actionTypes from './activeUsersActionTypes.js';
export const activeUsersReducer = (state = {}, action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.NEW_ACTIVE_USER: {
            const newActiveUsers = {};
            Object.keys(action.payload).forEach((tenant) => {
                const users = state[tenant];
                const newUsers = action.payload[tenant];
                if (!users) {
                    newActiveUsers[tenant] = newUsers;
                    return;
                }
                const filteredUsers = newUsers.filter((newUser) => {
                    return !users.find((user) => user.wsId === newUser.wsId);
                });
                newActiveUsers[tenant] = [...users, ...filteredUsers];
            });
            return { ...newActiveUsers };
        }
        case actionTypes.NEW_USER_ACTIVITY: {
            const users = state[payload.tenantId] || [];
            return {
                ...state,
                [payload.tenantId]: users
                    ? users.map((user) => {
                        if (user.wsId !== payload.wsId) {
                            return user;
                        }
                        const activities = user.activities.filter((activity) => activity.type !== payload.activity.type ||
                            activity.handle !== payload.activity.handle);
                        return {
                            ...user,
                            activities: [...activities, payload.activity],
                        };
                    })
                    : [],
            };
        }
        case actionTypes.REMOVE_USER_ACTIVITY: {
            const users = state[payload.tenantId] || [];
            return {
                ...state,
                [payload.tenantId]: users.map((user) => user.wsId === payload.wsId
                    ? {
                        ...user,
                        activities: user.activities.filter((a) => a.type !== payload.data.type ||
                            a.handle !== payload.data.handle),
                    }
                    : user),
            };
        }
        case actionTypes.USER_LEFT: {
            const newState = {};
            Object.keys(action.payload).forEach((tenant) => {
                const users = state[tenant] || [];
                newState[tenant] = users.filter((user) => action.payload[tenant].indexOf(user.wsId) === -1);
            });
            return { ...state, ...newState };
        }
        case actionTypes.RESET_ACTIVE_USERS: {
            return {};
        }
        default:
            return state;
    }
};
//# sourceMappingURL=activeUsersReducer.js.map